import React from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

// Importa el locale español desde date-fns
import es from 'date-fns/locale/es';

// Registra el locale con react-datepicker
registerLocale('es', es);

const SeleccionaFecha = ({ selectedDate, handleDateChange }) => {
  return (
    <div>
      <DatePicker
        selected={selectedDate}
        onChange={handleDateChange}
        dateFormat="dd/MM/yyyy"
        placeholderText="Seleccione una fecha"
        locale="es" // 👈 Establece el idioma del calendario
        className="text-xs border border-gray-300 p-2 rounded"
      />
    </div>
  );
};

export default SeleccionaFecha;

